export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <path d="M8.16666 12.8335L27.4 30.3335L47.8333 12.8335" stroke="#F7A40A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="7" y="11.6665" width="42" height="32.6667" rx="2.33333" stroke="black" strokeWidth="2.5" />
        </svg>
    );
}
